import { appLogoPath } from '@suite/contracts';

/**
 * Logos oficiales de las apps de la suite: SVG autocontenidos en `public/logos/<code>.svg`, generados con
 * `pnpm logos` (`scripts/logos-apps.mjs`) a partir del ícono y el color del catálogo. La lista vive en
 * `@suite/contracts` (`APPS_WITH_LOGO`): el API manda la misma URL a las apps en `GET /v1/service/entities/:slug`.
 * Una app sin logo aquí se dibuja con `LogoApp` a partir de `apps.icon` y `apps.color`.
 */
export const appLogo = (code: string): string | null => appLogoPath(code);
